import { render, staticRenderFns } from "./QualityControlReportAdd.vue?vue&type=template&id=b36e95ae&scoped=true"
import script from "./QualityControlReportAdd.vue?vue&type=script&lang=js"
export * from "./QualityControlReportAdd.vue?vue&type=script&lang=js"
import style0 from "./QualityControlReportAdd.vue?vue&type=style&index=0&id=b36e95ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36e95ae",
  null
  
)

export default component.exports